import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import TimePickerCustom from './TimePickerCustom';
import apiClient from '../../Services/NetteApiClient';

loadDOMComponent({
	selector: 'react-time-picker-custom',
	callback: ({ container }) => {
		let times = container.getAttribute('times');
		times = JSON.parse(times);

		const changeUrl = container.getAttribute('onchangeurl');
		let value = container.getAttribute('value');
		value = value ? JSON.parse(value) : null;

		const handleChange = time => {
			console.log({ tt: time });
			apiClient.post(changeUrl, {
				date: time.date,
				from: time.from,
				to: time.to,
				priceId: time?.priceId,
			});
		};

		ReactDOM.render(
			<AppContextProvider>
				<TimePickerCustom times={times} onChange={handleChange} value={value} />
			</AppContextProvider>,
			container,
		);
	},
});
